// to prevent lenis from being imported on build by default in utils.js or avoid circular dependency in main.js
import Lenis from '@studio-freight/lenis'
export const lenis = new Lenis()
